






























import { Component, Vue } from 'vue-property-decorator'
import { VImageUpload } from '@/components/upload'
import { QueryIndexHomeConfig, UpdateIndexHomeConfig } from '@/api'
import { Message } from 'element-ui'

@Component({
  components: { VImageUpload },
})
export default class IndexHomeConfigPage extends Vue {
  private form = {
    logo: '',
    title: '',
    subtitle: '',
    livePlaceholder: '',
    yxytBanner: '',
    huiminBanner: '',
    zunxiangBanner: '',
    xingouBanner: '',
  }
  private logoList: any[] = []
  private livePlaceholderList: any[] = []
  private yxytBannerList: any[] = []
  private huiminBannerList: any[] = []
  private zunxiangBannerList: any[] = []
  private xingouBannerList: any[] = []

  public async created() {
    await this.loadData()
  }

  private onLogoChange(list: any[]) {
    this.logoList = list
    this.form.logo = list && list.length ? list[0].url : ''
  }

  private onLivePlaceholderChange(list: any[]) {
    this.livePlaceholderList = list
    this.form.livePlaceholder = list && list.length ? list[0].url : ''
  }

  private onYxytBannerChange(list: any[]) {
    this.yxytBannerList = list
    this.form.yxytBanner = list && list.length ? list[0].url : ''
  }

  private onHuiminBannerChange(list: any[]) {
    this.huiminBannerList = list
    this.form.huiminBanner = list && list.length ? list[0].url : ''
  }

  private onZunxiangBannerChange(list: any[]) {
    this.zunxiangBannerList = list
    this.form.zunxiangBanner = list && list.length ? list[0].url : ''
  }

  private onXingouBannerChange(list: any[]) {
    this.xingouBannerList = list
    this.form.xingouBanner = list && list.length ? list[0].url : ''
  }

  private async loadData() {
    const res = await QueryIndexHomeConfig({})
    this.form.logo = res.logo || ''
    this.form.title = res.title || ''
    this.form.subtitle = res.subtitle || ''
    this.form.livePlaceholder = res.livePlaceholder || ''
    this.form.yxytBanner = res.yxytBanner || ''
    this.form.huiminBanner = res.huiminBanner || ''
    this.form.zunxiangBanner = res.zunxiangBanner || ''
    this.form.xingouBanner = res.xingouBanner || ''
    this.logoList = this.form.logo ? [{ url: this.form.logo }] : []
    this.livePlaceholderList = this.form.livePlaceholder ? [{ url: this.form.livePlaceholder }] : []
    this.yxytBannerList = this.form.yxytBanner ? [{ url: this.form.yxytBanner }] : []
    this.huiminBannerList = this.form.huiminBanner ? [{ url: this.form.huiminBanner }] : []
    this.zunxiangBannerList = this.form.zunxiangBanner ? [{ url: this.form.zunxiangBanner }] : []
    this.xingouBannerList = this.form.xingouBanner ? [{ url: this.form.xingouBanner }] : []
  }

  private async save() {
    await UpdateIndexHomeConfig({ ...this.form })
    Message.success('保存成功')
  }
}
